import { ref } from 'vue';
import { defineStore } from 'pinia';


export const useLocaleStore = defineStore("locale", () => {
    const storedLocale = localStorage.getItem('locale') || 'ar';
    const locale = ref(storedLocale);

    const setLocale = (l: string) => {
        locale.value = l;
        localStorage.setItem('locale', l);
    };

    const getLocale = () => {
        return locale.value;
    };

    return {
        locale,
        setLocale,
        getLocale,
    };
}, {
    persist: {
        storage: localStorage,
    }
});
